module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.active) ? _c('div', {
    staticClass: "modalContainer"
  }, [_c('div', {
    class: {
      modal: true, autoHeight: _vm.heigth == 'auto'
    },
    style: ({
      heigth: _vm.heigth
    }),
    attrs: {
      "id": "modalContent"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), (_vm.currentModal == 'save') ? _c('modal-save') : _vm._e(), _vm._v(" "), (_vm.currentModal == 'addedToCart') ? _c('modal-added-to-cart') : _vm._e(), _vm._v(" "), (_vm.currentModal == 'message') ? _c('modal-message', {
    attrs: {
      "message-data": _vm.modalData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentModal == 'share') ? _c('modal-share') : _vm._e(), _vm._v(" "), (_vm.currentModal == 'noStock') ? _c('modal-no-stock') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modalBG",
    on: {
      "click": _vm.close
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e6e96eb!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Modals/Modal.vue
// module id = 157
// module chunks = 0